import { Component } from '@angular/core';

@Component({
  selector: 'app1',
  templateUrl: './app1.component.html'
})
export class App1Component {
  text = 'Hello world';
  diffuseColor = '#dd3300';

  ngOnInit() {
    console.log("app1");
  }
}